import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { IGeoJson2DGeographicCoordinates } from '~/client/graph'
import PermitListItem from '~/client/src/shared/components/PermitListItem'
import LocationBase from '~/client/src/shared/models/LocationObjects/LocationBase'
import Workflow from '~/client/src/shared/models/Workflow'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'

import MapViewItemBase from '../SitemapHelpers/models/MapViewItemBase'
import GeneralMapPopup, { MapPopupBody } from './GeneralMapPopup'

interface IProps {
  item: MapViewItemBase
  selectedSitePermits: Workflow[]
  selectedPermitId: string
  coordOverride?: IGeoJson2DGeographicCoordinates
  offset?: number
  sharedFromProjectName?: string

  openPermit(permit: Workflow): void
  onClose(): void
  closeOnMapClick?: boolean

  locationAttributesStore?: LocationAttributesStore
}

@inject('locationAttributesStore')
@observer
export default class FormMapPopup extends React.Component<IProps> {
  public render() {
    const {
      item,
      selectedSitePermits = [],
      selectedPermitId,
      openPermit,
      onClose,
      closeOnMapClick,
      coordOverride,
      offset,
      sharedFromProjectName,
    } = this.props

    if (!selectedSitePermits.length) {
      return
    }

    return (
      <GeneralMapPopup
        item={item}
        sitemapLocation={selectedSitePermits[0]?.locations[0]}
        coordOverride={coordOverride}
        offset={offset}
        headerLocation={this.headerLocation}
        sharedFromProjectName={sharedFromProjectName}
        onClose={onClose}
        closeOnMapClick={closeOnMapClick}
      >
        <MapPopupBody>
          {selectedSitePermits.map(permit => (
            <PermitListItem
              key={permit.id}
              permit={permit}
              onClick={openPermit}
              isSelected={permit.id === selectedPermitId}
            />
          ))}
        </MapPopupBody>
      </GeneralMapPopup>
    )
  }

  // `item` (see GeneralMapPopup's headerLocation) can't name an equipment-only
  // pin. Resolve the workflow's primary association through the store instead:
  // it is display- and globe-agnostic, unlike `displayedGlobeViewItems`, which
  // is empty by design once the map falls back to the project marker.
  private get headerLocation(): LocationBase {
    const { selectedSitePermits, locationAttributesStore } = this.props
    // Pins group by raw coordinate, so one popup can list workflows sitting on
    // different locations — name the pin only when they all agree on one.
    const ids = selectedSitePermits.map(p => p.locationsWithEquipment[0]?.id)
    const [id] = ids
    return id && ids.every(other => other === id)
      ? locationAttributesStore.getById(id)
      : null
  }
}
